module.exports = __webpack_public_path__ + "media/customizations/regencyatoldetowne/logo-0d1e2bf6b1ddb30a9b54f32f45e713b9.png";